import { Stack } from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import { useFetchMealCreditDetails } from 'src/components/oneCorp/features/MealCredit/components/Form/hooks/useFetchMealCreditDetails';
import { AccordionSections } from 'src/components/oneCorp/features/MealCredit/components/DetailsPage/AccordionSections/AccordionSections';
import { AssignPeopleAndGroupsHeader } from 'src/components/oneCorp/features/MealCredit/components/Headers/AssignPeopleAndGroupsHeader';
import { DetailsHeader } from 'src/components/oneCorp/features/MealCredit/components/Headers/DetailsHeader';
import { MealCreditEditDetailsRoutes } from 'src/components/oneCorp/features/MealCredit/components/Routes/MealCreditEditDetailsRoutes';
import { AccordionStencil } from 'src/components/oneCorp/features/MealCredit/components/Stencils/AccordionStencil';
import { SectionLoader } from 'src/components/oneCorp/features/MealCredit/components/Stencils/SectionLoader';
import { useRedirectExpiredMealCredit } from 'src/components/oneCorp/features/MealCredit/components/DetailsPage/MealCreditController/useRedirectExpiredMealCredit';

export interface MealCreditControllerProps {
  corpId: string;
  mealCreditId: string;
}
export function MealCreditController({
  corpId,
  mealCreditId,
}: MealCreditControllerProps): JSX.Element {
  const { mealCredit, fetchMealCredit } = useFetchMealCreditDetails({
    corpId,
    mealCreditId,
  });

  const isMealCreditActive = useRedirectExpiredMealCredit({
    mealCredit,
    corpId,
  });

  return (
    <>
      <Stack y="md">
        <DetailsHeader />
      </Stack>
      <Stack y="lg">
        {isMealCreditActive ? (
          <MealCreditEditDetailsRoutes
            corpId={corpId}
            mealCredit={mealCredit}
            fetchMealCredit={fetchMealCredit}
          />
        ) : (
          <SectionLoader />
        )}
      </Stack>
      <Stack y="md">
        <AssignPeopleAndGroupsHeader />
      </Stack>
      {isMealCreditActive ? (
        <AccordionSections
          corpId={corpId}
          mealCredit={mealCredit}
          fetchMealCredit={fetchMealCredit}
        />
      ) : (
        <AccordionStencil />
      )}
    </>
  );
}
